import React, { useState, useEffect } from 'react';
import './VariantB.css';

// SVG Icons (Zero unicode emojis for clean enterprise aesthetic)
const Icons = {
  Check: () => (
    <svg className="vb-svg-check" viewBox="0 0 20 20" fill="currentColor">
      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
    </svg>
  ),
  Lock: () => (
    <svg className="vb-svg-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  ),
  ArrowRight: () => (
    <svg className="vb-svg-arrow" viewBox="0 0 20 20" fill="currentColor">
      <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
    </svg>
  ),
  OwnerIcon: () => (
    <svg className="vb-role-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2 2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  TenantIcon: () => (
    <svg className="vb-role-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Mail: () => (
    <svg className="vb-footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  MapPin: () => (
    <svg className="vb-footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ),
  IndiaFlag: () => (
    <svg className="vb-flag-svg" viewBox="0 0 30 20" fill="none">
      <rect width="30" height="6.67" fill="#FF9933" />
      <rect y="6.67" width="30" height="6.67" fill="#FFFFFF" />
      <rect y="13.34" width="30" height="6.67" fill="#138808" />
      <circle cx="15" cy="10" r="2.3" fill="none" stroke="#000080" strokeWidth="0.5" />
      <circle cx="15" cy="10" r="0.6" fill="#000080" />
    </svg>
  ),
  MultiProperty: () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <rect x="6" y="14" width="20" height="28" rx="3" fill="#eff6ff" stroke="#1d4ed8" strokeWidth="2.5" />
      <rect x="22" y="8" width="20" height="34" rx="3" fill="#f8fafc" stroke="#0f172a" strokeWidth="2.5" />
      <rect x="10" y="20" width="4" height="4" rx="1" fill="#3b82f6" />
      <rect x="18" y="20" width="4" height="4" rx="1" fill="#3b82f6" />
      <rect x="10" y="28" width="4" height="4" rx="1" fill="#3b82f6" />
      <rect x="18" y="28" width="4" height="4" rx="1" fill="#3b82f6" />
      <rect x="27" y="14" width="4" height="4" rx="1" fill="#0284c7" />
      <rect x="34" y="14" width="4" height="4" rx="1" fill="#0284c7" />
      <rect x="27" y="22" width="4" height="4" rx="1" fill="#0284c7" />
      <rect x="34" y="22" width="4" height="4" rx="1" fill="#0284c7" />
      <rect x="27" y="30" width="4" height="4" rx="1" fill="#0284c7" />
      <rect x="34" y="30" width="4" height="4" rx="1" fill="#0284c7" />
      <rect x="30" y="36" width="5" height="6" fill="#1d4ed8" />
    </svg>
  ),
  CloudSecurity: () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path d="M14 28a8 8 0 0115.5-2.7A6.5 6.5 0 0139 30a6 6 0 01-6 6H14a7 7 0 010-14c.3 0 .7 0 1 .1" fill="#ecfdf5" stroke="#059669" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M24 12l8 3.5v6c0 6-4.8 10.5-8 12.5-3.2-2-8-6.5-8-12.5v-6l8-3.5z" fill="#ffffff" stroke="#1d4ed8" strokeWidth="2.2" strokeLinejoin="round" />
      <path d="M21 21.5l2.5 2.5 4.5-4.5" stroke="#059669" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  AuditReports: () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <rect x="8" y="6" width="26" height="34" rx="3.5" fill="#ffffff" stroke="#0f172a" strokeWidth="2.5" />
      <path d="M14 14h14M14 20h10" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
      <path d="M14 34v-5" stroke="#0284c7" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M19 34v-9" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M24 34v-13" stroke="#059669" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="34" cy="32" r="9" fill="#eff6ff" stroke="#1d4ed8" strokeWidth="2" />
      <text x="34" y="35" textAnchor="middle" fill="#1d4ed8" fontSize="8" fontWeight="900" fontFamily="sans-serif">PDF</text>
    </svg>
  ),
  GooglePlay: () => (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none">
      <path d="M1.2 1.1l11.4 11.2L1.2 23.5c-.4-.3-.7-.9-.7-1.7V2.8c0-.8.3-1.4.7-1.7z" fill="#00C1A6"/>
      <path d="M16.1 7.8L12.6 12.3 1.2 1.1c.3-.2.8-.3 1.4 0l13.5 6.7z" fill="#FFD400"/>
      <path d="M16.1 16.8L2.6 23.5c-.6.3-1.1.2-1.4 0l11.4-11.2 3.5 4.5z" fill="#FF3333"/>
      <path d="M21.2 10.4c.9.5.9 1.4 0 1.9l-5.1 4.5-3.5-4.5 3.5-4.5 5.1 4.5z" fill="#0083FF"/>
    </svg>
  ),
  AppStore: () => (
    <svg width="22" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.37c.62-.75 1.04-1.8 1.01-2.87-.96.04-2.12.64-2.79 1.43-.59.68-1.1 1.77-1 2.81 1.08.08 2.16-.62 2.78-1.37z" />
    </svg>
  ),
  QrCode: () => (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="currentColor" className="vb-qr-svg">
      <rect x="8" y="8" width="28" height="28" rx="4" fill="none" stroke="currentColor" strokeWidth="6" />
      <rect x="16" y="16" width="12" height="12" rx="2" fill="currentColor" />
      <rect x="64" y="8" width="28" height="28" rx="4" fill="none" stroke="currentColor" strokeWidth="6" />
      <rect x="72" y="16" width="12" height="12" rx="2" fill="currentColor" />
      <rect x="8" y="64" width="28" height="28" rx="4" fill="none" stroke="currentColor" strokeWidth="6" />
      <rect x="16" y="72" width="12" height="12" rx="2" fill="currentColor" />
      <rect x="42" y="10" width="6" height="6" fill="currentColor" />
      <rect x="52" y="10" width="6" height="6" fill="currentColor" />
      <rect x="42" y="20" width="6" height="6" fill="currentColor" />
      <rect x="52" y="30" width="6" height="6" fill="currentColor" />
      <rect x="42" y="42" width="16" height="16" rx="3" fill="#1d4ed8" />
      <rect x="10" y="44" width="6" height="6" fill="currentColor" />
      <rect x="24" y="44" width="6" height="6" fill="currentColor" />
      <rect x="70" y="44" width="6" height="6" fill="currentColor" />
      <rect x="84" y="44" width="6" height="6" fill="currentColor" />
      <rect x="42" y="64" width="6" height="6" fill="currentColor" />
      <rect x="52" y="72" width="6" height="6" fill="currentColor" />
      <rect x="42" y="84" width="6" height="6" fill="currentColor" />
      <rect x="64" y="64" width="6" height="6" fill="currentColor" />
      <rect x="74" y="74" width="6" height="6" fill="currentColor" />
      <rect x="84" y="64" width="6" height="6" fill="currentColor" />
      <rect x="64" y="84" width="16" height="6" fill="currentColor" />
      <rect x="84" y="76" width="6" height="14" fill="currentColor" />
    </svg>
  )
};

export default function VariantB() {
  const [heroMobile, setHeroMobile] = useState('');
  const [heroError, setHeroError] = useState('');
  const [selectedRole, setSelectedRole] = useState('owner');

  const [bannerMobile, setBannerMobile] = useState('');
  const [bannerError, setBannerError] = useState('');

  useEffect(() => {
    document.title = 'Hisab OK - Digital Rent Collection & Property Ledger';
    document.body.style.paddingBottom = '0px';
    document.body.style.overflowX = 'clip';
    return () => { 
      document.body.style.paddingBottom = ''; 
      document.body.style.overflowX = '';
    };
  }, []);

  const handleHeroPhoneChange = (e) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 10);
    setHeroMobile(val);
    if (heroError && val.length === 10) setHeroError('');
  };

  const isValidIndianMobile = (num) => /^[6-9]\d{9}$/.test(num);

  const handleHeroSubmit = () => {
    const cleanMobile = heroMobile.replace(/\D/g, '');
    if (!cleanMobile || cleanMobile.length !== 10) {
      setHeroError('Please enter a valid 10-digit mobile number');
      return;
    }
    if (!isValidIndianMobile(cleanMobile)) {
      setHeroError('Mobile number must start with 6, 7, 8 or 9');
      return;
    }
    setHeroError('');
    executeRedirect(cleanMobile, selectedRole);
  };

  const handleHeroKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleHeroSubmit();
    }
  };

  const handleBannerPhoneChange = (e) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 10);
    setBannerMobile(val);
    if (bannerError && val.length === 10) setBannerError('');
  };

  const handleBannerSubmit = () => {
    const cleanMobile = bannerMobile.replace(/\D/g, '');
    if (!cleanMobile || cleanMobile.length !== 10) {
      setBannerError('Please enter a valid 10-digit mobile number');
      return;
    }
    if (!isValidIndianMobile(cleanMobile)) {
      setBannerError('Mobile number must start with 6, 7, 8 or 9');
      return;
    }
    setBannerError('');
    executeRedirect(cleanMobile, 'owner');
  };

  const handleBannerKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleBannerSubmit();
    }
  };

  const getTargetBaseUrl = (role) => {
    if (role === 'tenant' && process.env.REACT_APP_TENANT_URL) {
      return process.env.REACT_APP_TENANT_URL;
    }
    if (role === 'owner' && process.env.REACT_APP_OWNER_URL) {
      return process.env.REACT_APP_OWNER_URL;
    }
    if (process.env.REACT_APP_URL) {
      return process.env.REACT_APP_URL;
    }

    const isLocal = typeof window !== 'undefined' && 
      (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    if (isLocal) {
      return 'http://localhost:8081';
    }

    const hostname = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();

    if (hostname.includes('dev03') || hostname.includes('dev-03')) {
      return role === 'tenant'
        ? 'https://hisabok-mobile-dev03-b.web.app'
        : 'https://hisabok-mobile-dev03-a.web.app';
    }

    if (hostname === 'hisabok.com' || hostname === 'www.hisabok.com') {
      return role === 'tenant'
        ? 'https://tenant.hisabok.com'
        : 'https://app.hisabok.com';
    }

    return role === 'tenant'
      ? 'https://hisabok-mobile-tenant-dev01.web.app'
      : 'https://hisabok-mobile-dev01.web.app';
  };

  const executeRedirect = (mobileToPass, roleToUse) => {
    const role = roleToUse || selectedRole;
    const cleanMobile = (mobileToPass || '').replace(/\D/g, '');
    const targetUrl = getTargetBaseUrl(role);
    const params = new URLSearchParams();

    if (cleanMobile.length === 10) {
      params.append('mobile', cleanMobile);
    }
    if (role) {
      params.append('role', role);
    }

    const queryString = params.toString();
    const finalUrl = queryString ? `${targetUrl}?${queryString}` : targetUrl;

    window.location.href = finalUrl;
  };

  return (
    <div className="vb-root">
      {/* HEADER / NAVBAR */}
      <header className="vb-navbar">
        <div className="vb-container vb-navbar-inner">
          <a href="/b" className="vb-brand-wrap" aria-label="Hisab OK Home">
            <img src="/img/logo.jpg" alt="Hisab OK" className="vb-brand-logo" />
          </a>

          <div className="vb-nav-actions">
            <button 
              type="button" 
              onClick={() => executeRedirect('', 'owner')} 
              className="vb-btn-navbar"
              aria-label="Login to Web App"
            >
              <span>Login to Web App</span>
              <Icons.ArrowRight />
            </button>
          </div>
        </div>
      </header>

      {/* HERO SECTION */}
      <section className="vb-hero-section">
        <div className="vb-container vb-hero-grid">
          <div className="vb-hero-left">
            <h1 className="vb-hero-title">
              Collect Rent On Time. <br />
              <span className="vb-gradient-text">Without Diary Chaos or Awkward Calls.</span>
            </h1>

            <p className="vb-hero-subtitle">
              Paper registers and uncomfortable reminder calls are history. Automate polite WhatsApp notices, track room-wise pending dues accurately, and collect rent directly to your UPI.
            </p>

            {/* ACTION CARD (Role Selection & Phone CTA) */}
            <div className="vb-action-card">
              <div className="vb-role-selector">
                <button
                  type="button"
                  className={`vb-role-btn ${selectedRole === 'owner' ? 'active' : ''}`}
                  onClick={() => setSelectedRole('owner')}
                  aria-pressed={selectedRole === 'owner'}
                >
                  <Icons.OwnerIcon />
                  <div className="vb-role-text-wrap">
                    <span className="vb-role-title">PG / Property Owner</span>
                    <span className="vb-role-hint">Manage Rooms &amp; Dues</span>
                  </div>
                </button>
                <button
                  type="button"
                  className={`vb-role-btn ${selectedRole === 'tenant' ? 'active' : ''}`}
                  onClick={() => setSelectedRole('tenant')}
                  aria-pressed={selectedRole === 'tenant'}
                >
                  <Icons.TenantIcon />
                  <div className="vb-role-text-wrap">
                    <span className="vb-role-title">Tenant / Kirayedaar</span>
                    <span className="vb-role-hint">Pay Rent &amp; Receipts</span>
                  </div>
                </button>
              </div>

              <div className="vb-input-box">
                <span className="vb-prefix">+91</span>
                <input
                  type="tel"
                  maxLength="10"
                  placeholder="Enter 10-digit mobile number"
                  value={heroMobile}
                  onChange={handleHeroPhoneChange}
                  onKeyDown={handleHeroKeyDown}
                  className="vb-phone-input"
                  aria-label="Mobile Number"
                />
                <button 
                  type="button" 
                  onClick={handleHeroSubmit} 
                  className={`vb-submit-btn ${selectedRole === 'tenant' ? 'vb-btn-tenant-tone' : ''}`}
                >
                  <span>{selectedRole === 'owner' ? 'Open Dashboard' : 'Pay Rent Online'}</span>
                  <Icons.ArrowRight />
                </button>
              </div>

              {heroError && <div className="vb-input-error">{heroError}</div>}

              <div className="vb-card-security-note">
                <Icons.Lock />
                <span>Instant OTP Login • Zero Passwords Needed • 100% Safe &amp; Secure</span>
              </div>
            </div>
          </div>

          <div className="vb-hero-right">
            <div className="vb-hero-illustration-wrap">
              <picture>
                <source 
                  srcSet="/img/modern_premium_indian_fintech_vector_illustration_of_a_confident_smiling_indian.webp" 
                  type="image/webp" 
                />
                <img 
                  src="/img/modern_premium_indian_fintech_vector_illustration_of_a_confident_smiling_indian.png" 
                  alt="Hisab OK - Confident Property Owner with Digital Ledger" 
                  className="vb-hero-character-img"
                  fetchPriority="high"
                  loading="eager"
                  width="540"
                  height="450"
                />
              </picture>
            </div>
          </div>
        </div>
      </section>

      {/* STATS SECTION */}
      <section className="vb-stats-section">
        <div className="vb-container">
          <div className="vb-stats-strip">
            <div className="vb-stat-box">
              <div className="vb-stat-number">3x</div>
              <div className="vb-stat-heading">Faster Dues Recovery</div>
              <p className="vb-stat-sub">Automated WhatsApp alerts</p>
            </div>
            <div className="vb-stat-divider"></div>
            <div className="vb-stat-box">
              <div className="vb-stat-number">100%</div>
              <div className="vb-stat-heading">Calculation Accuracy</div>
              <p className="vb-stat-sub">Zero calculation disputes</p>
            </div>
            <div className="vb-stat-divider"></div>
            <div className="vb-stat-box">
              <div className="vb-stat-number">₹0</div>
              <div className="vb-stat-heading">Free to Get Started</div>
              <p className="vb-stat-sub">No credit card required</p>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURE SHOWCASE: HIGH-RES ARTWORK STORIES */}
      <section className="vb-features-section" id="features">
        <div className="vb-container">
          <div className="vb-section-intro">
            <span className="vb-pill-tag">Why Choose Hisab OK</span>
            <h2 className="vb-intro-title">Built for Real Indian Property &amp; Business Owners</h2>
            <p className="vb-intro-desc">
              Everyday tools designed to solve real operational bottlenecks without technical complexity.
            </p>
          </div>

          <div className="vb-features-natural-list">
            {/* ROW 1: WhatsApp Reminders */}
            <div className="vb-natural-row">
              <div className="vb-natural-text">
                <span className="vb-natural-pill">Automated Reminders</span>
                <h3 className="vb-natural-title">WhatsApp &amp; SMS Payment Notices</h3>
                <p className="vb-natural-desc">
                  Never feel awkward asking for money. Send courteous, automated payment updates on WhatsApp with exact due breakups and direct UPI links. Collect rent on time with zero manual follow-ups.
                </p>
                <ul className="vb-natural-points">
                  <li><Icons.Check /><span>Personalized notices with current month and past backlog dues</span></li>
                  <li><Icons.Check /><span>Direct UPI deep-links for immediate 1-tap rent settlement</span></li>
                  <li><Icons.Check /><span>Visual 5-badge timeline to track delivery and scheduled notices</span></li>
                </ul>
              </div>
              <div className="vb-natural-graphic">
                <img 
                  src="/img/graphics-feature01.jpg" 
                  alt="WhatsApp Payment Reminders" 
                />
              </div>
            </div>

            {/* ROW 2: Zero Calculation Errors */}
            <div className="vb-natural-row vb-natural-reverse">
              <div className="vb-natural-text">
                <span className="vb-natural-pill">Zero Calculation Errors</span>
                <h3 className="vb-natural-title">Accurate Month-Wise Dues &amp; Settled History</h3>
                <p className="vb-natural-desc">
                  Replace manual diaries and paper registers for good. Hisab OK automatically tallies monthly billing cycles, partial deposits, and historical balances with verified date-stamped entries and green settlement checkmarks.
                </p>
                <ul className="vb-natural-points">
                  <li><Icons.Check /><span>Automatic recurring rent additions on tenant billing cycles</span></li>
                  <li><Icons.Check /><span>Separate transparent tracking for current rent vs previous dues</span></li>
                  <li><Icons.Check /><span>Verified settlement ticks eliminating tenant disputes forever</span></li>
                </ul>
              </div>
              <div className="vb-natural-graphic">
                <img 
                  src="/img/graphics-feature02.jpg" 
                  alt="Expected Rent and Settled Ledger" 
                />
              </div>
            </div>

            {/* ROW 3: Customer & Room Directory */}
            <div className="vb-natural-row">
              <div className="vb-natural-text">
                <span className="vb-natural-pill">Directory &amp; Rooms</span>
                <h3 className="vb-natural-title">Organize Every Tenant, Room &amp; Due Date</h3>
                <p className="vb-natural-desc">
                  Search any tenant by mobile number or name in seconds. Track floor-wise rooms, student joining dates, and expected payment calendars across single or multiple properties with a single tap.
                </p>
                <ul className="vb-natural-points">
                  <li><Icons.Check /><span>Quick mobile search with complete historical payment records</span></li>
                  <li><Icons.Check /><span>Calendar-based alerts for today's expected and pending dues</span></li>
                  <li><Icons.Check /><span>Seamless switching between multiple PGs or business branches</span></li>
                </ul>
              </div>
              <div className="vb-natural-graphic">
                <img 
                  src="/img/graphics-vendor01.jpg" 
                  alt="Customer Directory & Calendar Reminders" 
                />
              </div>
            </div>

            {/* ROW 4: Instant Receipts & Statements */}
            <div className="vb-natural-row vb-natural-reverse">
              <div className="vb-natural-text">
                <span className="vb-natural-pill">Digital Receipts</span>
                <h3 className="vb-natural-title">Instant PDF Receipts &amp; 1-Tap Account Settlement</h3>
                <p className="vb-natural-desc">
                  Whenever rent is received via cash, UPI, or bank transfer, record the entry in seconds and share an itemized digital receipt directly on the tenant's WhatsApp. Maintain 100% transparency.
                </p>
                <ul className="vb-natural-points">
                  <li><Icons.Check /><span>Itemized digital PDF statements with your property branding</span></li>
                  <li><Icons.Check /><span>One-click settlement marking full account clearance</span></li>
                  <li><Icons.Check /><span>Downloadable monthly audit reports for effortless accounting</span></li>
                </ul>
              </div>
              <div className="vb-natural-graphic">
                <img 
                  src="/img/graphics-vendor03.jpg" 
                  alt="Smart All-in-One Solution and Instant Receipts" 
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS / 3 STEPS */}
      <section className="vb-steps-section" id="how-it-works">
        <div className="vb-container">
          <div className="vb-section-intro">
            <span className="vb-pill-tag">Simple Process</span>
            <h2 className="vb-intro-title">Get Started in 3 Simple Steps</h2>
            <p className="vb-intro-desc">No complicated installation or training needed. Start managing in under 2 minutes.</p>
          </div>

          <div className="vb-steps-grid">
            <div className="vb-step-card">
              <div className="vb-step-num">1</div>
              <h3 className="vb-step-name">Sign In with Mobile</h3>
              <p className="vb-step-detail">Enter your 10-digit number and verify instantly with OTP. No passwords, zero card details required.</p>
            </div>

            <div className="vb-step-card">
              <div className="vb-step-num">2</div>
              <h3 className="vb-step-name">Add Rooms &amp; Tenants</h3>
              <p className="vb-step-detail">Input tenant name, room number, monthly rent amount, and billing date in just a few taps.</p>
            </div>

            <div className="vb-step-card">
              <div className="vb-step-num">3</div>
              <h3 className="vb-step-name">Collect &amp; Track Payments</h3>
              <p className="vb-step-detail">Send automated WhatsApp reminders, record collections, and view clean ledger balances in real time.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ENTERPRISE TRUST & PROPERTY CAPABILITIES (TAILORED FOR HISAB OK) */}
      <section className="vb-more-features-section" id="security">
        <div className="vb-container">
          <div className="vb-more-features-card">
            <div className="vb-more-features-header">
              <span className="vb-pill-tag">Enterprise Capabilities</span>
              <h2 className="vb-more-features-title">Engineered for Scalable &amp; Secure Property Operations</h2>
              <p className="vb-more-features-subtitle">
                Everything you need to run multiple PGs, hostels, or rental flats smoothly with zero manual calculations and total peace of mind.
              </p>
            </div>
            
            <div className="vb-more-features-grid">
              <div className="vb-more-feature-col">
                <div className="vb-more-feature-icon">
                  <Icons.MultiProperty />
                </div>
                <h3 className="vb-more-feature-title">Multi-PG &amp; Branch Operations</h3>
                <p className="vb-more-feature-desc">
                  Manage multiple PGs, hostels, or commercial buildings under a single owner login. Switch between branches with one tap.
                </p>
              </div>

              <div className="vb-more-feature-col">
                <div className="vb-more-feature-icon">
                  <Icons.CloudSecurity />
                </div>
                <h3 className="vb-more-feature-title">100% Automated Cloud Backup</h3>
                <p className="vb-more-feature-desc">
                  Your tenant ledgers and records are secured with 256-bit bank-grade encryption. Instantly recoverable if you switch devices.
                </p>
              </div>

              <div className="vb-more-feature-col">
                <div className="vb-more-feature-icon">
                  <Icons.AuditReports />
                </div>
                <h3 className="vb-more-feature-title">Room-Wise Audits &amp; PDF Reports</h3>
                <p className="vb-more-feature-desc">
                  Download date-wise rent collections, pending dues breakups, and itemized PDF statements ready for effortless accounting.
                </p>
              </div>
            </div>

            <div className="vb-more-features-trust-bar">
              <div className="vb-trust-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                <span>256-Bit Bank-Grade SSL</span>
              </div>
              <div className="vb-trust-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1d4ed8" strokeWidth="2.5"><path d="M20 17.58A5 5 0 0018 8h-1.26A8 8 0 104 16.25"/></svg>
                <span>Real-Time Cloud Backup</span>
              </div>
              <div className="vb-trust-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0284c7" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                <span>Dual Mobile &amp; Web Access</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRE-FOOTER APP DOWNLOAD & GET STARTED CTA BANNER (HISAB OK ECOSYSTEM) */}
      <section className="vb-cta-banner-section">
        <div className="vb-container">
          <div className="vb-khatabook-banner">
            {/* LEFT: Heading, Phone Input + Button, Features */}
            <div className="vb-kb-left">
              <h2 className="vb-kb-title">
                Get started with<br />Hisab OK.
              </h2>
              <div className="vb-kb-input-row">
                <div className="vb-kb-input-box">
                  <span className="vb-kb-prefix">+91</span>
                  <input
                    type="tel"
                    maxLength="10"
                    placeholder="Enter your Phone Number"
                    value={bannerMobile}
                    onChange={handleBannerPhoneChange}
                    onKeyDown={handleBannerKeyDown}
                    className="vb-kb-input"
                    aria-label="Phone Number"
                  />
                </div>
                <button
                  type="button"
                  onClick={handleBannerSubmit}
                  className="vb-kb-submit-btn"
                >
                  Get Started
                </button>
              </div>
              {bannerError && <div className="vb-input-error" style={{ marginTop: '8px', color: '#ef4444', fontSize: '0.875rem' }}>{bannerError}</div>}
              <div className="vb-kb-features">
                <span>Manage Digital PG Hisab</span>
                <span className="vb-kb-divider">|</span>
                <span>Send WhatsApp Reminders for easy collection</span>
              </div>
            </div>

            {/* CENTER: Clean Upright Smartphone */}
            <div className="vb-kb-center">
              <picture>
                <source srcSet="/img/phone_perfect_cut.webp" type="image/webp" />
                <img
                  src="/img/phone_perfect_cut.png"
                  alt="Hisab OK Mobile App Tenant Ledger"
                  className="vb-kb-phone-img"
                  loading="lazy"
                  width="420"
                  height="340"
                />
              </picture>
            </div>

            {/* RIGHT: QR Code + Download Badges */}
            <div className="vb-kb-right">
              <div className="vb-kb-qr-box">
                <Icons.QrCode />
              </div>
              <span className="vb-kb-qr-label">Scan to download the app</span>
              <div className="vb-kb-store-buttons">
                <a
                  href="https://play.google.com/store/apps"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="vb-kb-store-badge"
                  title="Get Hisab OK on Google Play"
                >
                  <Icons.GooglePlay />
                  <div className="vb-kb-badge-text">
                    <span className="vb-kb-badge-sub">GET IT ON</span>
                    <span className="vb-kb-badge-title">Google Play</span>
                  </div>
                </a>

                <a
                  href="https://apple.com/app-store/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="vb-kb-store-badge"
                  title="Download Hisab OK on the App Store"
                >
                  <Icons.AppStore />
                  <div className="vb-kb-badge-text">
                    <span className="vb-kb-badge-sub">Download on the</span>
                    <span className="vb-kb-badge-title">App Store</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="vb-footer">
        <div className="vb-container">
          <div className="vb-footer-layout">
            <div className="vb-col-brand">
              <img src="/img/logo.jpg" alt="Hisab OK" className="vb-footer-logo" />
              <p className="vb-footer-bio">
                Hisab OK is Digital India's leading rent collection and customer ledger management platform, helping landlords and business owners automate daily operations.
              </p>
              <div className="vb-footer-contacts">
                <div className="vb-contact-row">
                  <Icons.Mail />
                  <span>info@hisabok.com</span>
                </div>
                <div className="vb-contact-row">
                  <Icons.MapPin />
                  <span>Awfis Majestic Signia, Sector 62, Noida, UP - 201309</span>
                </div>
              </div>
            </div>

            <div className="vb-col-links">
              <h4 className="vb-footer-heading">Product</h4>
              <a href="#features">Features</a>
              <a href="#how-it-works">How It Works</a>
              <a href="#security">Security &amp; Encryption</a>
            </div>

            <div className="vb-col-links">
              <h4 className="vb-footer-heading">Portals</h4>
              <button type="button" onClick={() => executeRedirect('', 'owner')} className="vb-footer-btn-link">Owner Web Dashboard</button>
              <button type="button" onClick={() => executeRedirect('', 'tenant')} className="vb-footer-btn-link">Tenant Rent Portal</button>
              <button type="button" onClick={() => executeRedirect('', 'owner')} className="vb-footer-btn-link">Quick OTP Login</button>
            </div>

            <div className="vb-col-links">
              <h4 className="vb-footer-heading">Legal</h4>
              <a href="#security">Privacy Policy</a>
              <a href="#security">Terms of Service</a>
              <a href="#security">Data Protection</a>
            </div>
          </div>

          <div className="vb-footer-bottom">
            <p className="vb-footer-copyright">© {new Date().getFullYear()} Hisab OK. All rights reserved.</p>
            <div className="vb-footer-pride-badge">
              <Icons.IndiaFlag />
              <span className="vb-pride-text">Built with pride for Indian Businesses</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
